/**
  jQuery Unveil
 * A very lightweight jQuery plugin to lazy load images
 * http://luis-almeida.github.com/unveil
 *
 * Licensed under the MIT license.
 * Copyright 2013 Luís Almeida
 * https://github.com/luis-almeida
 *
 * HEAVILY MODIFIED FOR VERTICAL SCROLLING OF PARENT ELEMENTS
 */

define(["jquery", "postal", "ko-visibilitychange"], function ($, postal){
  $.fn.unveil = function(threshold, parentSelector, callback) {

    var $w = $(window),
        $p = $(parentSelector),
        th = threshold || 0,
        retina = window.devicePixelRatio > 1,
        attrib = retina ? "data-src-retina" : "data-src",
        backgroundAttrib ="data-background-src",
        images = this,
        loaded;

    this.one("unveil", function() {
      var source = this.getAttribute(attrib);
      var backgroundSource = this.getAttribute(backgroundAttrib);
      source = source || this.getAttribute("data-src");
      if (source) {
        this.setAttribute("src", source);
        if (typeof callback === "function") callback.call(this);
      }
      if (backgroundSource) {
        $(this).css("background-image", "url('"+backgroundSource+"')"); 
        if (typeof callback === "function") callback.call(this);
      }
    });

    function isElementInViewport( el ) {
      //special bonus for those using jQuery
      if ( typeof $ === "function" && el instanceof $ ) {
        el = el[0];
      }

      var rect = el.getBoundingClientRect();
      // console.log({ "element": el, "rectangle": rect });

      return (
          rect.bottom >= 0 &&
          rect.left >= 0 &&
          rect.left <= ( window.innerWidth || document.documentElement.clientWidth ) &&
          (rect.top-th) <= ( window.innerHeight || document.documentElement.clientHeight )
      );
    }

    function unveil() {
      var inview = images.filter(function() {
        var $e = $(this);
        if ($e.is(":hidden")) return;

        return isElementInViewport($e);
      });

      loaded = inview.trigger("unveil");
      images = images.not(loaded);
    }

    $w.scroll(unveil);
    $p.scroll(unveil);

    $w.resize(unveil);
    $p.resize(unveil);
    postal.subscribe({
	  channel: "DOM",
	  topic: "visibilityChange",
	  callback: function() {
	    unveil();
	  }
    });

    unveil();

    return this;

  };
});
